import {RcnPriceStatsGrain} from "../types/IRcnPriceStats";
import {formatRcnPeriodMonth, formatRcnPeriodMonthGenitive, formatRcnPeriodYear} from "./format_rcn_period";
import {formatQuarterLabelForDate} from "./format_rcn_period_label";

/** A history point's period by the grain it was published in: "grudzień 2020", "IV kw. 2020", "2020 r.". */
export const formatRcnHistoryPeriod = (periodStart: string, grain: RcnPriceStatsGrain): string => {
    switch (grain) {
        case "month":
            return formatRcnPeriodMonth(periodStart);
        case "quarter":
            return formatQuarterLabelForDate(periodStart);
        default:
            return formatRcnPeriodYear(periodStart);
    }
};

/** The same period after "od" / "do": "od grudnia 2020 do marca 2022", "od IV kw. 2020 do II kw. 2022", "od 2020 do 2022". */
export const formatRcnHistoryPeriodInRange = (periodStart: string, grain: RcnPriceStatsGrain): string => {
    switch (grain) {
        case "month":
            return formatRcnPeriodMonthGenitive(periodStart);
        case "quarter":
            return formatQuarterLabelForDate(periodStart);
        default:
            return periodStart.slice(0, 4);
    }
};

/** The period named as the only one published: "grudzień 2020", "IV kw. 2020", "2020". */
export const formatRcnHistoryPeriodAlone = (periodStart: string, grain: RcnPriceStatsGrain): string =>
    grain === "year" ? periodStart.slice(0, 4) : formatRcnHistoryPeriod(periodStart, grain);
import {RcnPriceStatsGrain} from "../types/IRcnPriceStats";
import {formatRcnPeriodMonth, formatRcnPeriodMonthGenitive, formatRcnPeriodYear} from "./format_rcn_period";
import {formatQuarterLabelForDate} from "./format_rcn_period_label";

/** A history point's period by the grain it was published in: "grudzień 2020", "IV kw. 2020", "2020 r.". */
export const formatRcnHistoryPeriod = (periodStart: string, grain: RcnPriceStatsGrain): string => {
    switch (grain) {
        case "month":
            return formatRcnPeriodMonth(periodStart);
        case "quarter":
            return formatQuarterLabelForDate(periodStart);
        default:
            return formatRcnPeriodYear(periodStart);
    }
};

/** The same period after "od" / "do": "od grudnia 2020 do marca 2022", "od IV kw. 2020 do II kw. 2022", "od 2020 do 2022". */
export const formatRcnHistoryPeriodInRange = (periodStart: string, grain: RcnPriceStatsGrain): string => {
    switch (grain) {
        case "month":
            return formatRcnPeriodMonthGenitive(periodStart);
        case "quarter":
            return formatQuarterLabelForDate(periodStart);
        default:
            return periodStart.slice(0, 4);
    }
};

/** The period named as the only one published: "grudzień 2020", "IV kw. 2020", "2020". */
export const formatRcnHistoryPeriodAlone = (periodStart: string, grain: RcnPriceStatsGrain): string =>
    grain === "year" ? periodStart.slice(0, 4) : formatRcnHistoryPeriod(periodStart, grain);
